import { ActiveRatingStarSvg } from './tip-checkout-rating-card.styles';

const starBurstDots = [
  {
    className: 'burst-dot burst-dot--one',
    d: 'M37.6188 15.4333C36.0702 15.4233 34.9526 14.3122 34.9376 12.7656C34.9275 11.2241 36.1855 9.95786 37.689 9.9929C39.2125 10.0329 40.4554 11.3242 40.4103 12.8257C40.3652 14.2822 39.1223 15.4433 37.6188 15.4333Z',
    fill: '#FFA31D',
  },
  {
    className: 'burst-dot burst-dot--two',
    d: 'M43.0915 41.4894C41.5429 41.4794 40.4253 40.3683 40.4102 38.8218C40.4002 37.2803 41.6581 36.014 43.1616 36.049C44.6852 36.0891 45.9281 37.3804 45.883 38.8819C45.8379 40.3383 44.595 41.4995 43.0915 41.4894Z',
    fill: '#FFA31D',
  },
  {
    className: 'burst-dot burst-dot--three',
    d: 'M22.7673 55.9372C21.2186 55.9272 20.101 54.8161 20.086 53.2696C20.076 51.728 21.3339 50.4618 22.8374 50.4968C24.361 50.5368 25.6039 51.8281 25.5588 53.3296C25.5137 54.7861 24.2708 55.9472 22.7673 55.9372Z',
    fill: '#FFA31D',
  },
  {
    className: 'burst-dot burst-dot--four',
    d: 'M2.68132 39.8288C1.1327 39.8188 0.0150946 38.7077 5.94905e-05 37.1612C-0.00996393 35.6196 1.24798 34.3534 2.75149 34.3884C4.27505 34.4284 5.51795 35.7197 5.47284 37.2212C5.42774 38.6777 4.18483 39.8388 2.68132 39.8288Z',
    fill: '#FFA31D',
  },
  {
    className: 'burst-dot burst-dot--five',
    d: 'M9.65788 15.4333C8.10926 15.4233 6.99166 14.3122 6.97662 12.7656C6.9666 11.2241 8.22454 9.95786 9.72805 9.9929C11.2516 10.0329 12.4945 11.3242 12.4494 12.8257C12.4043 14.2822 11.1614 15.4433 9.65788 15.4333Z',
    fill: '#FFA31D',
  },
] as const;

const starBurstTrails = [
  {
    className: 'burst-trail burst-trail--one',
    d: 'M50.6619 21.3675C48.1011 18.3646 46.7036 18.878 46.4695 22.9078C46.7164 26.8466 45.5595 27.3146 42.9987 24.3117C40.3469 20.8278 38.9039 21.1007 38.6699 25.1305C39.0077 29.5503 37.8508 30.0183 35.199 26.5344',
    stroke: '#FF8800',
  },
  {
    className: 'burst-trail burst-trail--two',
    d: 'M22.0016 42.0003C23.0913 38.2071 21.8916 37.3255 18.4026 39.3554C15.2549 41.7361 14.226 41.0299 15.3157 37.2368C16.7561 33.1022 15.7318 32.0499 12.2428 34.0798C8.74437 36.802 7.7154 36.0957 9.15585 31.9612',
    stroke: '#FF8800',
  },
  {
    className: 'burst-trail burst-trail--three',
    d: 'M34.3473 1.5798C28.8803 1.08001 27.4862 2.92857 30.1652 7.12548C33.4964 10.888 32.406 12.7643 26.8942 12.7545C21.3824 12.7446 19.9883 14.5931 22.7121 18.3001C25.391 22.497 23.997 24.3456 18.5299 23.8458',
    stroke: '#FB6712',
  },
  {
    className: 'burst-trail burst-trail--four',
    d: 'M42.3914 52.7288C43.6161 49.0651 42.575 47.812 39.2681 48.9694C36.1535 50.6436 35.0444 49.594 35.9408 45.8206C36.8372 42.0471 35.7962 40.794 32.8176 42.0612C29.5108 43.2186 28.4697 41.9654 29.6944 38.3017',
    stroke: '#FB6712',
  },
] as const;

export function ActiveRatingStarIcon() {
  return (
    <ActiveRatingStarSvg>
      <path
        className="burst-star"
        d="M42.0838 28.4186L35.0842 35.3978L36.7364 45.2522C36.9601 46.592 36.4316 47.9202 35.3566 48.7194C34.7485 49.1704 34.0384 49.3992 33.3217 49.3992C32.7704 49.3992 32.2175 49.2633 31.7052 48.988L23.0517 44.3352L14.3982 48.988C13.2227 49.6198 11.8234 49.517 10.7468 48.7177C9.67181 47.9185 9.14323 46.5903 9.36698 45.2505L11.0192 35.3961L4.01795 28.4169C3.06618 27.4685 2.73055 26.0756 3.14076 24.7823C3.55098 23.4889 4.62435 22.5653 5.93932 22.3696L15.6143 20.932L19.9402 11.9664C20.5288 10.7476 21.7205 9.98987 23.0484 9.98987C24.3764 9.98987 25.5697 10.7476 26.1567 11.9664L30.4842 20.932L40.1592 22.3696C41.4741 22.5653 42.5459 23.4889 42.9577 24.7823C43.368 26.0756 43.0323 27.4668 42.0806 28.4169L42.0838 28.4186Z"
        fill="#FFBE00"
      />
      {starBurstDots.map(dot => (
        <path
          className={dot.className}
          d={dot.d}
          fill={dot.fill}
          key={dot.className}
        />
      ))}
      {starBurstTrails.map(trail => (
        <path
          className={trail.className}
          d={trail.d}
          fill="none"
          key={trail.className}
          pathLength="1"
          stroke={trail.stroke}
          strokeLinecap="round"
          strokeWidth="3"
        />
      ))}
    </ActiveRatingStarSvg>
  );
}
